module.exports = __webpack_public_path__ + "img/春节大促_26.29e769b6.png";